import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CountdownBadge } from './CountdownBadge';
export function HeroSection() {
  return <section className="bg-blue-900 text-white py-2 md:py-2" data-id="element-217">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="text-center max-w-2xl mx-auto" data-id="element-219">
          <h1 className="text-3xl md:text-4xl font-extrabold mb-6 leading-tight md:leading-snug" data-id="element-220">
            Quick Recipes To Nourish Your Baby Confidently. No More Stress, No More Wasted Food
          </h1>
          <p className="text-lg md:text-xl mb-8 text-blue-100" data-id="element-221">
            By Dr. Claire Morgan, Pediatric Nutritionist
          </p>
          <a href="#pricing" className="w-[60%] md:w-[70%] flex justify-center md:inline-flex items-center bg-yellow-500 hover:bg-yellow-400 text-blue-900 font-bold py-3 px-6 rounded-lg text-lg transition-colors mb-4 mx-auto" data-id="element-222">
            Download Now
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-223" />
          </a>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-6" data-id="element-224">
            
            <div className="text-xl font-bold" data-id="element-225">
              Limited time offer <span className="line-through" data-id="element-226">$60</span>{' '}
              <span className="text-2xl text-yellow-400" data-id="element-227">$14.97</span>
            </div>
            <CountdownBadge data-id="element-228" />
          </div>
          <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-229">
            <div className="mb-2 md:mb-0 md:order-2 md:w-[40%]" data-id="element-230">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vi76xjzU4PxnVuUb2z8wYG/Baby-Food_Made_Simple.jpg" alt="Baby Food Made Simple ebook cover showing healthy baby food recipes" className="mx-auto rounded-lg shadow-xl max-w-full md:max-w-xs" data-id="element-231" />
            </div>
            <div className="md:w-[60%] md:order-1 p-2 md:p-8 text-left" data-id="element-232">
              <h2 className="text-2xl md:text-2xl font-bold mb-4" data-id="element-233">
               Finally, baby food recipes organized by your baby's exact age and texture tolerance
              </h2>
              <p className="text-lg mb-6" data-id="element-234">
               No more Pinterest recipes that worked for someone else's 8-month-old but fail with yours. No more guessing if the texture is right. Just a clear plan that matches your baby's actual developmental stage today.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}